/**
 * 城市/省份中心坐标工具
 * 替代百度 mapv.utilCityCenter
 * 坐标为高德坐标系 (GCJ-02)
 */

var provinceCenter = {
    '北京': { lng: 116.405285, lat: 39.904989 },
    '天津': { lng: 117.190122, lat: 39.125596 },
    '河北': { lng: 114.502461, lat: 38.045474 },
    '山西': { lng: 112.549248, lat: 37.857014 },
    '内蒙古': { lng: 111.670801, lat: 40.818311 },
    '辽宁': { lng: 123.429096, lat: 41.796767 },
    '吉林': { lng: 125.324544, lat: 43.886841 },
    '黑龙江': { lng: 126.642464, lat: 45.756967 },
    '上海': { lng: 121.472644, lat: 31.231706 },
    '江苏': { lng: 118.767413, lat: 32.041544 },
    '浙江': { lng: 120.153576, lat: 30.287459 },
    '安徽': { lng: 117.283042, lat: 31.86119 },
    '福建': { lng: 119.306239, lat: 26.075302 },
    '江西': { lng: 115.892151, lat: 28.682892 },
    '山东': { lng: 117.000923, lat: 36.675807 },
    '河南': { lng: 113.665412, lat: 34.757975 },
    '湖北': { lng: 114.298572, lat: 30.584355 },
    '湖南': { lng: 112.982279, lat: 28.19404 },
    '广东': { lng: 113.280637, lat: 23.125178 },
    '广西': { lng: 108.320004, lat: 22.82402 },
    '海南': { lng: 110.33119, lat: 20.031971 },
    '重庆': { lng: 106.504962, lat: 29.533155 },
    '四川': { lng: 104.065735, lat: 30.659462 },
    '贵州': { lng: 106.713478, lat: 26.578343 },
    '云南': { lng: 102.712251, lat: 25.038887 },
    '西藏': { lng: 91.132212, lat: 29.660361 },
    '陕西': { lng: 108.948024, lat: 34.263161 },
    '甘肃': { lng: 103.823557, lat: 36.058039 },
    '青海': { lng: 101.778916, lat: 36.623178 },
    '宁夏': { lng: 106.278179, lat: 38.46637 },
    '新疆': { lng: 87.617733, lat: 43.792818 },
    '台湾': { lng: 121.509062, lat: 25.044332 },
    '香港': { lng: 114.173355, lat: 22.320048 },
    '澳门': { lng: 113.549028, lat: 22.198951 },
};

var cityCenter = {
    // 直辖市
    '北京': { lng: 116.405285, lat: 39.904989 },
    '天津': { lng: 117.190122, lat: 39.125596 },
    '上海': { lng: 121.472644, lat: 31.231706 },
    '重庆': { lng: 106.504962, lat: 29.533155 },
    // 省会及主要城市
    '石家庄': { lng: 114.502461, lat: 38.045474 },
    '唐山': { lng: 118.175393, lat: 39.635113 },
    '秦皇岛': { lng: 119.586579, lat: 39.942531 },
    '邯郸': { lng: 114.490686, lat: 36.612273 },
    '邢台': { lng: 114.508866, lat: 37.068202 },
    '保定': { lng: 115.482331, lat: 38.867657 },
    '张家口': { lng: 114.884091, lat: 40.767534 },
    '承德': { lng: 117.939152, lat: 40.976205 },
    '沧州': { lng: 116.857461, lat: 38.310582 },
    '廊坊': { lng: 116.704441, lat: 39.523927 },
    '衡水': { lng: 115.665993, lat: 37.735226 },
    '太原': { lng: 112.549248, lat: 37.857014 },
    '大同': { lng: 113.295259, lat: 40.09097 },
    '阳泉': { lng: 113.583285, lat: 37.861188 },
    '长治': { lng: 113.113556, lat: 36.191112 },
    '晋城': { lng: 112.851274, lat: 35.497553 },
    '朔州': { lng: 112.433387, lat: 39.331261 },
    '晋中': { lng: 112.736465, lat: 37.696495 },
    '运城': { lng: 111.003957, lat: 35.022778 },
    '忻州': { lng: 112.733538, lat: 38.41769 },
    '临汾': { lng: 111.517973, lat: 36.08415 },
    '吕梁': { lng: 111.134335, lat: 37.524366 },
    '呼和浩特': { lng: 111.670801, lat: 40.818311 },
    '包头': { lng: 109.840405, lat: 40.658168 },
    '乌海': { lng: 106.825563, lat: 39.673734 },
    '赤峰': { lng: 118.956367, lat: 42.275317 },
    '通辽': { lng: 122.263119, lat: 43.617429 },
    '鄂尔多斯': { lng: 109.99029, lat: 39.817179 },
    '呼伦贝尔': { lng: 119.758668, lat: 49.21538 },
    '巴彦淖尔': { lng: 107.416959, lat: 40.757402 },
    '乌兰察布': { lng: 113.114543, lat: 41.034126 },
    '沈阳': { lng: 123.429096, lat: 41.796767 },
    '大连': { lng: 121.618622, lat: 38.91459 },
    '鞍山': { lng: 122.995632, lat: 41.110626 },
    '抚顺': { lng: 123.921109, lat: 41.875956 },
    '本溪': { lng: 123.770519, lat: 41.285981 },
    '丹东': { lng: 124.323544, lat: 40.124297 },
    '锦州': { lng: 121.135742, lat: 41.119269 },
    '营口': { lng: 122.235151, lat: 40.667432 },
    '阜新': { lng: 121.648962, lat: 42.011796 },
    '辽阳': { lng: 123.18152, lat: 41.269402 },
    '盘锦': { lng: 122.06957, lat: 41.124484 },
    '铁岭': { lng: 123.844279, lat: 42.299757 },
    '朝阳': { lng: 120.451176, lat: 41.576758 },
    '葫芦岛': { lng: 120.856394, lat: 40.755572 },
    '长春': { lng: 125.324544, lat: 43.886841 },
    '吉林': { lng: 126.55302, lat: 43.843577 },
    '四平': { lng: 124.370785, lat: 43.170344 },
    '辽源': { lng: 125.145349, lat: 42.902692 },
    '通化': { lng: 125.936501, lat: 41.721177 },
    '白山': { lng: 126.427839, lat: 41.942505 },
    '松原': { lng: 124.823608, lat: 45.118243 },
    '白城': { lng: 122.841114, lat: 45.619026 },
    '哈尔滨': { lng: 126.642464, lat: 45.756967 },
    '齐齐哈尔': { lng: 123.95792, lat: 47.342081 },
    '鸡西': { lng: 130.975966, lat: 45.300046 },
    '鹤岗': { lng: 130.277487, lat: 47.332085 },
    '双鸭山': { lng: 131.157304, lat: 46.643442 },
    '大庆': { lng: 125.11272, lat: 46.590734 },
    '伊春': { lng: 128.899396, lat: 47.727523 },
    '佳木斯': { lng: 130.361634, lat: 46.809606 },
    '七台河': { lng: 131.015584, lat: 45.771266 },
    '牡丹江': { lng: 129.618602, lat: 44.582961 },
    '黑河': { lng: 127.499023, lat: 50.249585 },
    '绥化': { lng: 126.99293, lat: 46.637393 },
    '南京': { lng: 118.767413, lat: 32.041544 },
    '无锡': { lng: 120.301663, lat: 31.574729 },
    '徐州': { lng: 117.184811, lat: 34.261772 },
    '常州': { lng: 119.946973, lat: 31.772752 },
    '苏州': { lng: 120.619585, lat: 31.299379 },
    '南通': { lng: 120.864608, lat: 32.016212 },
    '连云港': { lng: 119.178821, lat: 34.600018 },
    '淮安': { lng: 119.021265, lat: 33.597506 },
    '盐城': { lng: 120.139998, lat: 33.377631 },
    '扬州': { lng: 119.421003, lat: 32.393159 },
    '镇江': { lng: 119.452753, lat: 32.204402 },
    '泰州': { lng: 119.915176, lat: 32.484882 },
    '宿迁': { lng: 118.275162, lat: 33.963008 },
    '杭州': { lng: 120.153576, lat: 30.287459 },
    '宁波': { lng: 121.549792, lat: 29.868388 },
    '温州': { lng: 120.672111, lat: 28.000575 },
    '嘉兴': { lng: 120.750865, lat: 30.762653 },
    '湖州': { lng: 120.102398, lat: 30.867718 },
    '绍兴': { lng: 120.582112, lat: 29.997117 },
    '金华': { lng: 119.649506, lat: 29.089524 },
    '衢州': { lng: 118.87263, lat: 28.941708 },
    '舟山': { lng: 122.106863, lat: 30.016028 },
    '台州': { lng: 121.428599, lat: 28.661378 },
    '丽水': { lng: 119.921786, lat: 28.451993 },
    '合肥': { lng: 117.283042, lat: 31.86119 },
    '芜湖': { lng: 118.376451, lat: 31.326319 },
    '蚌埠': { lng: 117.363228, lat: 32.939667 },
    '淮南': { lng: 117.025449, lat: 32.626446 },
    '马鞍山': { lng: 118.507906, lat: 31.689362 },
    '淮北': { lng: 116.794664, lat: 33.971707 },
    '铜陵': { lng: 117.816576, lat: 30.929935 },
    '安庆': { lng: 117.053571, lat: 30.525311 },
    '黄山': { lng: 118.317325, lat: 29.709239 },
    '滁州': { lng: 118.316264, lat: 32.303627 },
    '阜阳': { lng: 115.819729, lat: 32.896969 },
    '宿州': { lng: 116.984084, lat: 33.633891 },
    '六安': { lng: 116.507676, lat: 31.734885 },
    '亳州': { lng: 115.782939, lat: 33.869338 },
    '池州': { lng: 117.489157, lat: 30.656037 },
    '宣城': { lng: 118.757995, lat: 30.945667 },
    '福州': { lng: 119.306239, lat: 26.075302 },
    '厦门': { lng: 118.11022, lat: 24.490474 },
    '莆田': { lng: 119.007558, lat: 25.431011 },
    '三明': { lng: 117.435001, lat: 26.265444 },
    '泉州': { lng: 118.589421, lat: 24.908853 },
    '漳州': { lng: 117.661801, lat: 24.510897 },
    '南平': { lng: 118.178459, lat: 26.635627 },
    '龙岩': { lng: 117.02978, lat: 25.091603 },
    '宁德': { lng: 119.527082, lat: 26.665717 },
    '南昌': { lng: 115.892151, lat: 28.682892 },
    '景德镇': { lng: 117.214664, lat: 29.29256 },
    '萍乡': { lng: 113.852186, lat: 27.622946 },
    '九江': { lng: 115.992811, lat: 29.712034 },
    '新余': { lng: 114.930835, lat: 27.810834 },
    '鹰潭': { lng: 117.033838, lat: 28.238638 },
    '赣州': { lng: 114.940278, lat: 25.85097 },
    '吉安': { lng: 114.986373, lat: 27.111699 },
    '宜春': { lng: 114.391136, lat: 27.8043 },
    '抚州': { lng: 116.358351, lat: 27.98385 },
    '上饶': { lng: 117.971185, lat: 28.44442 },
    '济南': { lng: 117.000923, lat: 36.675807 },
    '青岛': { lng: 120.355173, lat: 36.082982 },
    '淄博': { lng: 118.047648, lat: 36.814939 },
    '枣庄': { lng: 117.557964, lat: 34.856424 },
    '东营': { lng: 118.494301, lat: 37.461271 },
    '烟台': { lng: 121.391382, lat: 37.539297 },
    '潍坊': { lng: 119.107078, lat: 36.70925 },
    '济宁': { lng: 116.587245, lat: 35.415393 },
    '泰安': { lng: 117.129063, lat: 36.194968 },
    '威海': { lng: 122.116394, lat: 37.509691 },
    '日照': { lng: 119.461208, lat: 35.428588 },
    '临沂': { lng: 118.326443, lat: 35.065282 },
    '德州': { lng: 116.29099, lat: 37.453968 },
    '聊城': { lng: 115.980367, lat: 36.456013 },
    '滨州': { lng: 118.016974, lat: 37.383542 },
    '菏泽': { lng: 115.469381, lat: 35.246531 },
    '郑州': { lng: 113.665412, lat: 34.757975 },
    '开封': { lng: 114.341447, lat: 34.797049 },
    '洛阳': { lng: 112.434468, lat: 34.663041 },
    '平顶山': { lng: 113.307718, lat: 33.735241 },
    '安阳': { lng: 114.352482, lat: 36.103442 },
    '鹤壁': { lng: 114.295444, lat: 35.748236 },
    '新乡': { lng: 113.883991, lat: 35.302616 },
    '焦作': { lng: 113.238266, lat: 35.23904 },
    '濮阳': { lng: 115.041299, lat: 35.768234 },
    '许昌': { lng: 113.826063, lat: 34.022956 },
    '漯河': { lng: 114.026405, lat: 33.575855 },
    '三门峡': { lng: 111.194099, lat: 34.777338 },
    '南阳': { lng: 112.540918, lat: 32.999082 },
    '商丘': { lng: 115.650497, lat: 34.437054 },
    '信阳': { lng: 114.075031, lat: 32.123274 },
    '周口': { lng: 114.649653, lat: 33.620357 },
    '驻马店': { lng: 114.024736, lat: 32.980169 },
    '武汉': { lng: 114.298572, lat: 30.584355 },
    '黄石': { lng: 115.077048, lat: 30.220074 },
    '十堰': { lng: 110.787916, lat: 32.646907 },
    '宜昌': { lng: 111.290843, lat: 30.702636 },
    '襄阳': { lng: 112.144146, lat: 32.042426 },
    '鄂州': { lng: 114.890593, lat: 30.396536 },
    '荆门': { lng: 112.204251, lat: 31.03542 },
    '孝感': { lng: 113.926655, lat: 30.926423 },
    '荆州': { lng: 112.23813, lat: 30.326857 },
    '黄冈': { lng: 114.879365, lat: 30.447711 },
    '咸宁': { lng: 114.328963, lat: 29.832798 },
    '随州': { lng: 113.37377, lat: 31.717497 },
    '长沙': { lng: 112.982279, lat: 28.19404 },
    '株洲': { lng: 113.151737, lat: 27.835806 },
    '湘潭': { lng: 112.944052, lat: 27.829738 },
    '衡阳': { lng: 112.607693, lat: 26.900358 },
    '邵阳': { lng: 111.46923, lat: 27.237842 },
    '岳阳': { lng: 113.132855, lat: 29.37029 },
    '常德': { lng: 111.691347, lat: 29.040225 },
    '张家界': { lng: 110.479921, lat: 29.127401 },
    '益阳': { lng: 112.355042, lat: 28.570066 },
    '郴州': { lng: 113.032067, lat: 25.793589 },
    '永州': { lng: 111.608019, lat: 26.434516 },
    '怀化': { lng: 109.977672, lat: 27.557483 },
    '娄底': { lng: 112.008497, lat: 27.728136 },
    '广州': { lng: 113.280637, lat: 23.125178 },
    '深圳': { lng: 114.085947, lat: 22.547 },
    '珠海': { lng: 113.553986, lat: 22.224979 },
    '汕头': { lng: 116.708463, lat: 23.37102 },
    '佛山': { lng: 113.122717, lat: 23.028762 },
    '韶关': { lng: 113.591544, lat: 24.801322 },
    '湛江': { lng: 110.384975, lat: 21.274898 },
    '肇庆': { lng: 112.472529, lat: 23.051546 },
    '江门': { lng: 113.094942, lat: 22.590431 },
    '茂名': { lng: 110.919229, lat: 21.659751 },
    '惠州': { lng: 114.412579, lat: 23.079404 },
    '梅州': { lng: 116.117582, lat: 24.299112 },
    '汕尾': { lng: 115.364238, lat: 22.774485 },
    '河源': { lng: 114.697802, lat: 23.746266 },
    '阳江': { lng: 111.975107, lat: 21.859222 },
    '清远': { lng: 113.051227, lat: 23.685022 },
    '东莞': { lng: 113.746262, lat: 23.046237 },
    '中山': { lng: 113.382391, lat: 22.521113 },
    '潮州': { lng: 116.632301, lat: 23.661701 },
    '揭阳': { lng: 116.355733, lat: 23.543778 },
    '云浮': { lng: 112.044439, lat: 22.929801 },
    '南宁': { lng: 108.320004, lat: 22.82402 },
    '柳州': { lng: 109.411703, lat: 24.314617 },
    '桂林': { lng: 110.299121, lat: 25.274215 },
    '梧州': { lng: 111.297604, lat: 23.474803 },
    '北海': { lng: 109.119254, lat: 21.473343 },
    '防城港': { lng: 108.345472, lat: 21.614631 },
    '钦州': { lng: 108.624175, lat: 21.967127 },
    '贵港': { lng: 109.602146, lat: 23.0936 },
    '玉林': { lng: 110.154393, lat: 22.63136 },
    '百色': { lng: 106.616285, lat: 23.897742 },
    '贺州': { lng: 111.552056, lat: 24.414141 },
    '河池': { lng: 108.062105, lat: 24.695899 },
    '来宾': { lng: 109.229772, lat: 23.733766 },
    '崇左': { lng: 107.353926, lat: 22.404108 },
    '海口': { lng: 110.33119, lat: 20.031971 },
    '三亚': { lng: 109.508268, lat: 18.247872 },
    '成都': { lng: 104.065735, lat: 30.659462 },
    '绵阳': { lng: 104.741722, lat: 31.46402 },
    '自贡': { lng: 104.773447, lat: 29.352765 },
    '攀枝花': { lng: 101.716007, lat: 26.580446 },
    '泸州': { lng: 105.443348, lat: 28.889138 },
    '德阳': { lng: 104.398651, lat: 31.127991 },
    '广元': { lng: 105.829757, lat: 32.433668 },
    '遂宁': { lng: 105.571331, lat: 30.513059 },
    '内江': { lng: 105.066138, lat: 29.58708 },
    '乐山': { lng: 103.761263, lat: 29.582024 },
    '南充': { lng: 106.082974, lat: 30.795281 },
    '眉山': { lng: 103.831788, lat: 30.048318 },
    '宜宾': { lng: 104.630116, lat: 28.760189 },
    '广安': { lng: 106.633369, lat: 30.456398 },
    '达州': { lng: 107.502262, lat: 31.209484 },
    '雅安': { lng: 103.001033, lat: 29.987722 },
    '巴中': { lng: 106.753669, lat: 31.858809 },
    '资阳': { lng: 104.641917, lat: 30.122211 },
    '贵阳': { lng: 106.713478, lat: 26.578343 },
    '六盘水': { lng: 104.846753, lat: 26.584643 },
    '遵义': { lng: 106.937265, lat: 27.706626 },
    '安顺': { lng: 105.932188, lat: 26.245548 },
    '毕节': { lng: 105.28501, lat: 27.301693 },
    '铜仁': { lng: 109.191555, lat: 27.718346 },
    '昆明': { lng: 102.712251, lat: 25.038887 },
    '曲靖': { lng: 103.797851, lat: 25.501557 },
    '玉溪': { lng: 102.543907, lat: 24.350461 },
    '保山': { lng: 99.167133, lat: 25.111802 },
    '昭通': { lng: 103.717216, lat: 27.336999 },
    '丽江': { lng: 100.233006, lat: 26.872108 },
    '普洱': { lng: 100.972344, lat: 22.777321 },
    '临沧': { lng: 100.08697, lat: 23.876225 },
    '拉萨': { lng: 91.132212, lat: 29.660361 },
    '日喀则': { lng: 88.885148, lat: 29.267519 },
    '昌都': { lng: 97.178452, lat: 31.136875 },
    '林芝': { lng: 94.362348, lat: 29.654693 },
    '山南': { lng: 91.766529, lat: 29.236023 },
    '那曲': { lng: 92.060214, lat: 31.476004 },
    '西安': { lng: 108.948024, lat: 34.263161 },
    '铜川': { lng: 108.979608, lat: 34.916582 },
    '宝鸡': { lng: 107.14487, lat: 34.369315 },
    '咸阳': { lng: 108.705117, lat: 34.333439 },
    '渭南': { lng: 109.502882, lat: 34.499381 },
    '延安': { lng: 109.49081, lat: 36.596537 },
    '汉中': { lng: 107.028621, lat: 33.077668 },
    '榆林': { lng: 109.741193, lat: 38.290166 },
    '安康': { lng: 109.029273, lat: 32.6903 },
    '商洛': { lng: 109.939776, lat: 33.868319 },
    '兰州': { lng: 103.823557, lat: 36.058039 },
    '嘉峪关': { lng: 98.289152, lat: 39.786529 },
    '金昌': { lng: 102.187888, lat: 38.514238 },
    '白银': { lng: 104.173606, lat: 36.54568 },
    '天水': { lng: 105.724998, lat: 34.578529 },
    '武威': { lng: 102.634697, lat: 37.929996 },
    '张掖': { lng: 100.455472, lat: 38.932897 },
    '平凉': { lng: 106.684691, lat: 35.54279 },
    '酒泉': { lng: 98.510795, lat: 39.744023 },
    '庆阳': { lng: 107.638372, lat: 35.734218 },
    '定西': { lng: 104.592462, lat: 35.579578 },
    '陇南': { lng: 104.929379, lat: 33.388598 },
    '西宁': { lng: 101.778916, lat: 36.623178 },
    '海东': { lng: 102.10327, lat: 36.502916 },
    '银川': { lng: 106.278179, lat: 38.46637 },
    '石嘴山': { lng: 106.376173, lat: 39.01333 },
    '吴忠': { lng: 106.199129, lat: 37.986165 },
    '固原': { lng: 106.285241, lat: 36.004561 },
    '中卫': { lng: 105.173065, lat: 37.514951 },
    '乌鲁木齐': { lng: 87.617733, lat: 43.792818 },
    '克拉玛依': { lng: 84.873946, lat: 45.595886 },
    '吐鲁番': { lng: 89.184078, lat: 42.947613 },
    '哈密': { lng: 93.51316, lat: 42.833248 },
    '库尔勒': { lng: 86.150169, lat: 41.768552 },
    '阿克苏': { lng: 80.265068, lat: 41.170712 },
    '喀什': { lng: 75.989138, lat: 39.467664 },
    '和田': { lng: 79.92533, lat: 37.110687 },
    '伊犁': { lng: 81.329636, lat: 43.92186 },
};

/**
 * 根据省份名称获取中心坐标
 * @param {string} name 省份名称
 * @returns {{lng: number, lat: number}}
 */
function getCenterByProvinceName(name) {
    if (!name) return { lng: 104.065735, lat: 30.659462 }; // 默认成都
    // 尝试直接匹配
    if (provinceCenter[name]) return provinceCenter[name];
    // 尝试模糊匹配（如"北京市"->"北京"）
    for (var key in provinceCenter) {
        if (name.indexOf(key) > -1 || key.indexOf(name) > -1) {
            return provinceCenter[key];
        }
    }
    return { lng: 104.065735, lat: 30.659462 };
}

/**
 * 根据城市名称获取中心坐标
 * @param {string} name 城市名称
 * @returns {{lng: number, lat: number}}
 */
function getCenterByCityName(name) {
    if (!name) return { lng: 104.065735, lat: 30.659462 };
    if (cityCenter[name]) return cityCenter[name];
    // 模糊匹配
    for (var key in cityCenter) {
        if (name.indexOf(key) > -1 || key.indexOf(name) > -1) {
            return cityCenter[key];
        }
    }
    // 尝试省份匹配
    if (provinceCenter[name]) return provinceCenter[name];
    return { lng: 104.065735, lat: 30.659462 };
}

export { getCenterByProvinceName, getCenterByCityName };
